import React, { forwardRef, memo, useImperativeHandle, useState } from 'react';
import { GoogleReCaptcha } from 'react-google-recaptcha-v3';
import captchaTokenService from '/react4xp/services/captcha-token-service';

type RecaptchaFunctions = {
    updateToken: () => void;
};

export const Recaptcha = memo(
    forwardRef<RecaptchaFunctions>((_props, ref) => {
        const [refreshReCaptcha, setRefreshReCaptcha] = useState(false);

        const onVerify = (token: string) => {
            captchaTokenService.setRecaptchaToken(token);
        };

        useImperativeHandle(ref, () => ({
            updateToken: () => {
                setRefreshReCaptcha((r) => !r);
            },
        }));

        return (
            <GoogleReCaptcha
                onVerify={onVerify}
                refreshReCaptcha={refreshReCaptcha}
            />
        );
    })
);
